<template>
  <div
    :class="{'v-svg': true, 'use-parent-color': useParentColor, 'v-svg-active' : active}"
    :style="style"
    v-html="content"
    v-on="$listeners"/>
</template>

<script>
  export default {
    name: 'VSvg',

    props: {
      h: {
        default: '3rem',
        type: String
      },

      active: {
        default: false,
        type: Boolean
      },

      useParentColor: {
        default: false,
        type: Boolean
      }
    },

    data() {
      return {
        content: null
      }
    },

    computed: {
      style() {
        return {
          height: this.h
        }
      }
    },

    async created() {
      const name = this.$slots.default[0].text.trim()
      const svgModule = await import(`!svg-inline-loader?classPrefix=true&idPrefix=true!@/assets/icons/${ name }.svg`)
      this.content = svgModule.default
    }
  }
</script>

<style lang="scss" scoped>
  .v-svg,
  .v-img {
    display: inline-flex;
    justify-content: center;
    /*-webkit-tap-highlight-color : transparent;*/
    vertical-align: middle;
  }

  .v-svg {
    :global(& svg) {
      height: 100%;
    }

    :global(&.use-parent-color svg g *):hover {
      fill: red;
    }

    :global(&.v-svg-active svg g *) {
      fill: red;
      opacity: 1;
    }
  }
</style>
